import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  standalone: false
})
export class ImageViewerComponent implements OnInit {

  @Input() imageUrl: string;
  zoom: number = 1;
  ngOnInit() {

  }
  private lastTouchDistance: number | null = null;

  zoomIn() {
    this.zoom = Math.min(this.zoom + 0.2, 3);
  }
  
  zoomOut() {
    this.zoom = Math.max(this.zoom - 0.2, 0.5);
  }
  
  resetZoom() {
    this.zoom = 1;
  }

  onWheel(event: WheelEvent) {
    event.preventDefault();
    if (event.deltaY < 0) {
      this.zoomIn();
    } else {
      this.zoomOut();
    }
  }

  onTouchStart(event: TouchEvent) {
    if (event.touches.length === 2) {
      this.lastTouchDistance = this.getTouchDistance(event);
    }
  }

  onTouchMove(event: TouchEvent) {
    if (event.touches.length === 2 && this.lastTouchDistance !== null) {
      const currentDistance = this.getTouchDistance(event);
      if (currentDistance > this.lastTouchDistance) {
        this.zoomIn();
      } else if (currentDistance < this.lastTouchDistance) {
        this.zoomOut();
      }
      this.lastTouchDistance = currentDistance;
    }
  }

  private getTouchDistance(event: TouchEvent): number {
    const [touch1, touch2] = Array.from(event.touches);
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

}
